import { useMemo } from "react";

/**
 * Variantes posibles para la sección de egreso.
 * Cada una corresponde a un estado distinto de la UI.
 */
export const EGRESO_VARIANT = {
  /** El vehículo fue compactado: no se muestra la sección de egreso. */
  OCULTO: "oculto",
  /** Ya egresó: se muestra el botón "Ver egreso". */
  YA_EGRESADO: "ya_egresado",
  /** Tiene infoJuzgado con levantamiento: se puede egresar. */
  PUEDE_EGRESAR: "puede_egresar",
  /** Tiene infoJuzgado pero sin levantamiento: egreso bloqueado. */
  BLOQUEADO: "bloqueado",
  /** Sin infoJuzgado: queda a criterio del corralón. */
  SIN_INFO: "sin_info",
};

/**
 * Deriva la variante de egreso a mostrar en DetailComponent.
 *
 * @param {{ egreso: any, compactado: any, infoJuzgado: object|null }} detail
 * @param {string} estado - Estado normalizado (de useEstado)
 * @param {string} ESTADO_COMPACTADO - Constante ESTADO.COMPACTADO
 * @returns {{ variant: string, levantamiento: object|null }}
 */
export function useEgresoStatus(detail, estado, ESTADO_COMPACTADO) {
  const levantamiento = useMemo(
    () => detail.infoJuzgado?.levantamiento ?? null,
    [detail.infoJuzgado]
  );

  const tienelevantamiento = useMemo(
    () => Boolean(levantamiento && !Array.isArray(levantamiento)),
    [levantamiento]
  );

  const variant = useMemo(() => {
    if (estado === ESTADO_COMPACTADO) return EGRESO_VARIANT.OCULTO;
    if (detail.egreso !== null) return EGRESO_VARIANT.YA_EGRESADO;

    if (detail.infoJuzgado !== null) {
      return tienelevantamiento
        ? EGRESO_VARIANT.PUEDE_EGRESAR
        : EGRESO_VARIANT.BLOQUEADO;
    }

    return EGRESO_VARIANT.SIN_INFO;
  }, [estado, ESTADO_COMPACTADO, detail.egreso, detail.infoJuzgado, tienelevantamiento]);

  return { variant, levantamiento };
}